import React from "react";
import { QuestionModel } from "../models/QuestionModel";

export const QuestionContext = React.createContext<QuestionModel>(undefined);

export default function useQuestion() {
    return React.useContext(QuestionContext);
}
